import React, { PropsWithChildren } from "react";
import { ErrorBoundary } from "@appsignal/react";
import appsignal from "./appsignal";

export default function ErrorHandler({
  children,
}: PropsWithChildren): React.ReactElement {
  return <ErrorBoundary instance={appsignal}>{children}</ErrorBoundary>;
}
